<template>
  <AdminLayout>
    <Head title="Feedback" />

    <template #sectionTitle> Feedback </template>

    <!--        <div data-canny />-->
    <iframe
      src="https://forms.monday.com/forms/embed/5914f3b433fb76e5b363dfe6df0458ec?r=use1"
      width="100%"
      height="100%"
      style="border: 0; box-shadow: 5px 5px 56px 0px rgba(0, 0, 0, 0.25)"
    ></iframe>
  </AdminLayout>
</template>

<style scoped>
.cannyAttribution {
  display: none;
}
</style>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link } from '@inertiajs/vue3'

export default {
  components: {
    AdminLayout,
    Head,
    Link
  },

  props: {
    boardId: {
      type: String,
      required: true
    },
    ssoToken: {
      type: String,
      required: true
    }
  },

  mounted() {
    ;(function (w, d, i, s) {
      function l() {
        if (!d.getElementById(i)) {
          var f = d.getElementsByTagName(s)[0],
            e = d.createElement(s)
          ;(e.type = 'text/javascript'),
            (e.async = !0),
            (e.src = 'https://canny.io/sdk.js'),
            f.parentNode.insertBefore(e, f)
        }
      }
      if ('function' != typeof w.Canny) {
        var c = function () {
          c.q.push(arguments)
        }
        ;(c.q = []),
          (w.Canny = c),
          'complete' === d.readyState
            ? l()
            : w.attachEvent
              ? w.attachEvent('onload', l)
              : w.addEventListener('load', l, !1)
      }
    })(window, document, 'canny-jssdk', 'script')

    Canny('render', {
      boardToken: this.boardId,
      basePath: null, // See step 2
      ssoToken: this.ssoToken, // See step 3,
      theme: 'light' // options: light [default], dark, auto
    })
  }
}
</script>
